import * as actionTypes from '../consts/actionTypes';

const initialState = {
    login: null,
    logout: null,
    error: null,
    loading: null,
    register: null,
    retrieve: null,
    confirm: null,
    validateUsername: null,
    passwordRecover: null,
    resetPassword: null,
    allUsers: null,
    userDetail: null,
};

export default function userReducer(state = initialState, action) {
    const DEFAULT = { ...state };
    const ACTIONS = {
        [actionTypes.SHOW_LOADING]: showLoading(),
        [actionTypes.SUCCESS_POST_LOGIN]: responseToReturn('login'),
        [actionTypes.SUCCESS_POST_GOOGLE_LOGIN]: responseToReturn('login'),
        [actionTypes.SUCCESS_POST_LOGOUT]: responseToReturn('logout'),
        [actionTypes.SUCCESS_POST_REGISTER]: responseToReturn('register'),
        [actionTypes.SUCCESS_GET_RETRIEVE_USER]: responseToReturn('retrieve'),
        [actionTypes.SUCCESS_POST_CONFIRM_USER]: responseToReturn('confirm'),
        [actionTypes.ERROR_LOGIN]: errorReturn('error'),
        [actionTypes.CLEAR_ERROR_LOGIN]: clearLoginError(),
        [actionTypes.SUCCESS_GET_VALIDATE_USERNAME]: responseToReturn('validateUsername'),
        [actionTypes.SUCCESS_POST_PASSWORD_RECOVER]: responseToReturn('passwordRecover'),
        [actionTypes.SUCCESS_PUT_RESET_PASSWORD]: responseToReturn('resetPassword'),
        [actionTypes.SUCCESS_GET_DETAIL_USER]: responseToReturn('userDetail'),
        [actionTypes.SUCCESS_GET_ALL_USERS]: responseToReturn('allUsers'),        
    };

    function responseToReturn(typeState) {
        let res = { ...state };
        if (action.response) {
            res = { ...state, [typeState]: action.response.data, loading: false, error:false };
        }
        return res;
    }

    function showLoading() {
        let res = { ...state };
        if (action.type === 'SHOW_LOADING') {
            res = { ...state, loading: action.payload,userDetail:null };
        }
        return res;
    }

    function clearLoginError() {
        let res = { ...state };
        if (action.type === 'CLEAR_ERROR_LOGIN') {
            res = { ...state, login: null, error: null, register: null, passwordRecover: null, resetPassword: null };
        }
        return res;
    }

    function errorReturn(typeState) {
        let res = { ...state };
        if (action.response) {
            res = { ...state, [typeState]: action.response };
        }
        return res;
    }

    let receiveAction = DEFAULT;

    if (ACTIONS[action.type] !== undefined) {
        receiveAction = ACTIONS[action.type];
    }

    return receiveAction;
}